import * as React from 'react'
import { observer, inject } from 'mobx-react'
import EventsStore from '../../../Stores/EventsStore'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { getEventsTableNew, getEventsTableInProgress } from '../../../Model/TroubleEventsTableItem'
import ExportToCsvComponent from '../../../Components/ExportToCsvComponent'
import { ExportType } from '../../../Stores/ExportStore'
import PageSizeComponent from '../../../Components/PageSizeComponent'

export interface ITroubleEventsPageProps {
    localizationStore?: LocalizationStore
    eventsStore?: EventsStore
}

@inject('localizationStore')
@inject('eventsStore')
@observer
export default class TroubleEventsPage extends React.Component<ITroubleEventsPageProps> {
    render() {
        return (
            <div className="troubleEvents questionnaires row pageCol-6">
                <div className="col-12">
                    <PageSizeComponent />
                </div>

                <div
                    className="col-6"
                >
                    <ExportToCsvComponent exportType={ExportType.TroubleEventsListNew} />
                    {getEventsTableNew()}
                </div>
                <div
                    className="col-6"
                >
                    <ExportToCsvComponent exportType={ExportType.TroubleEventsListInProgress} />
                    {getEventsTableInProgress()}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/TroubleEvent/TroubleEventsPage.tsx